import { useTranslation } from '../../locale/context';

import bets from '../assets/gameInterface/info_bets.png';
import settings from '../assets/gameInterface/info_settings.png';
import info from '../assets/gameInterface/info_info.png';
import fast from '../assets/gameInterface/info_fast.png';
import auto from '../assets/gameInterface/info_auto.png';
import spin from '../assets/gameInterface/info_spin.png';
import betAmount from '../assets/gameInterface/info_betamount.png';
import { GameConfigs } from '../../lib/globals/GameConfigs';

export default function GameInterface({ currentBet, currency }) {
	const { t } = useTranslation();

	return (
		<div className='wrapper'>
			<div className='content'>
				<div className='title'>{t('common.main_game_interface')}</div>
			</div>
			<div className='interface_wrapper'>
				<div
					className='description interface_description'
					style={{ flexWrap: 'wrap' }}
				>
					<div className='description_icon'>
						<img
							src={bets}
							alt='bets'
							style={{
								width: '100px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine1')}
						{t('gameRules.game_interface_desc.ruleLine2')}
					</span>
				</div>
				<div
					className='description interface_description'
					style={{ flexWrap: 'wrap' }}
				>
					<div className='description_icon'>
						<img
							src={betAmount}
							alt='bets'
							style={{
								width: '276px',
								marginTop: '10px'
							}}
						/>
					</div>
					<span className='interface_betamount_currency'>
						{t('common.bet_amount')} ({currency})
					</span>
					<span className='interface_betamount'>
						{(+currentBet).toLocaleString(undefined, {
							minimumFractionDigits: GameConfigs.config.currency_prec,
							maximumFractionDigits: GameConfigs.config.currency_prec
						})}
					</span>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine4')}
					</span>
				</div>
				<div className='description interface_description'>
					<div className='description_icon'>
						<img
							src={settings}
							alt='bets'
							style={{
								width: '50px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine6')}
					</span>
				</div>
				<div className='description interface_description'>
					<div className='description_icon'>
						<img
							src={info}
							alt='bets'
							style={{
								width: '50px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine7')}
					</span>
				</div>
				<div className='description interface_description'>
					<div className='description_icon'>
						<img
							src={fast}
							alt='bets'
							style={{
								width: '50px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine8')}
					</span>
				</div>
				<div className='description interface_description'>
					<div className='description_icon'>
						<img
							src={auto}
							alt='bets'
							style={{
								width: '50px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>
						- {t('gameRules.game_interface_desc.ruleLine9')}
					</span>
				</div>
				<div className='description interface_description'>
					<div className='description_icon'>
						<img
							src={spin}
							alt='bets'
							style={{
								width: '100px'
							}}
						/>
					</div>
					<span style={{ marginLeft: '10px' }}>- {t('common.start_game')}</span>
				</div>
			</div>
		</div>
	);
}
